export default {
    date: "Date",
    weight: "Weight",
    week: "Week",
    comment: "Comment"
}